export default __webpack_public_path__ + "static/media/923.8b800f6d.gif";